<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>RIWAYAT JABATAN PENDIDIK / TENAGA KEPENDIDIKAN</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Riwayat Jabatan Pendidik</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jabatan.$error}">
            <label> Jabatan PTK </label>
            <j-input
              v-model="$v.data_master.jabatan.$model"
              placeholder="Jabatan PTK"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sk_struktural.$error}">
            <label> SK Jabatan Struktural / Fungsional </label>
            <j-input
              v-model="$v.data_master.sk_struktural.$model"
              placeholder="SK Jabatan Struktural / Fungsional"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tmt_jabatan.$error}">
            <label> TMT SK </label>
            <j-datepicker
              v-model="$v.data_master.tmt_jabatan.$model"
              placeholder="TMT SK"
              format="MMM dd, yyyy"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Riwayat Jabatan Pendidik</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jabatan.$error}">
            <label> Jabatan PTK </label>
            <j-input
              v-model="$v.data_master.jabatan.$model"
              :disabled="readOnly"
              placeholder="Jabatan PTK"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sk_struktural.$error}">
            <label> SK Jabatan Struktural / Fungsional </label>
            <j-input
              v-model="$v.data_master.sk_struktural.$model"
              :disabled="readOnly"
              placeholder="SK Jabatan Struktural / Fungsional"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tmt_jabatan.$error}">
            <label> TMT SK </label>
            <j-datepicker
              v-model="$v.data_master.tmt_jabatan.$model"
              :disabled="readOnly"
              placeholder="TMT SK"
              format="MMM dd, yyyy"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jJabatanPendidik',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['jabatan', 'sk_struktural', 'tmt_jabatan'],
      options: {
        headings: {
          jabatan: 'JABATAN PTK',
          sk_struktural: 'SK JABATAN STRUKTURAL/FUNGSIONAL',
          tmt_jabatan: 'TMT SK',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['jabatan', 'sk_struktural', 'tmt_jabatan'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListJabatanPendidik(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        jabatan: '',
        sk_struktural: '',
        tmt_jabatan: null,
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createJabatanPendidik', 'updateJabatanPendidik', 'deleteJabatanPendidik']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jabatan: '',
        sk_struktural: '',
        tmt_jabatan: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jabatan: '',
        sk_struktural: '',
        tmt_jabatan: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        jabatan: param.row.jabatan,
        sk_struktural: param.row.sk_struktural,
        tmt_jabatan: param.row.tmt_jabatan,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        params.tmt_jabatan = params.tmt_jabatan ? this.$moment(params.tmt_jabatan).format('YYYY-MM-DD') : '';
        this.createJabatanPendidik(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        params.tmt_jabatan = params.tmt_jabatan ? this.$moment(params.tmt_jabatan).format('YYYY-MM-DD') : '';
        this.updateJabatanPendidik(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteJabatanPendidik(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        jabatan: { required },
        sk_struktural: { required },
        tmt_jabatan: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jJabatanPendidik.vue